import { render, staticRenderFns } from "./LaunchPage.vue?vue&type=template&id=3c0274df&scoped=true&"
import script from "./LaunchPage.vue?vue&type=script&lang=js&"
export * from "./LaunchPage.vue?vue&type=script&lang=js&"
import style0 from "./LaunchPage.vue?vue&type=style&index=0&id=3c0274df&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c0274df",
  null
  
)

export default component.exports